"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AUTO_PREFIX = void 0;
const AUTO_PREFIX = exports.AUTO_PREFIX = {};
const transform = AUTO_PREFIX;
var _default = exports.default = transform;